import React, { useEffect, useCallback, useState} from 'react';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {isNumber} from 'utils/IsNumber.js';
import {connect} from 'react-redux';

const ParameterInputEditor = ({setEditing, onUpdateParameter, value, editedValue}) => { 
    let [inputValue, setInputValue] = useState(value);
    
    const onTypedInputChanged = useCallback((val) => {
        if (!isNumber(val) && val !== '.' && val !== '' && val !== '-' &&
            val !== '-.') {
            return;
        }

        setInputValue(val);
        onUpdateParameter({target: {value: val}}, false);
    }, [setInputValue, onUpdateParameter]);

    const onKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            setEditing(false);
        }
    }, [setEditing]);

    return  (
        <InputGroup
          className="tag-sound-input">
          <Input
            value={inputValue}
            onKeyUp={onKeyPress}
            onChange={(event) => onTypedInputChanged(event.target.value)}
            placeholder="Parameter"
            className="parameter-input-box"/>
        </InputGroup>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParameterInputEditor);
